import React from 'react';

function NoStyleFound() {
	return (
		<div>
			<h2>No Styles Found</h2>
		</div>
	);
}

export default NoStyleFound;
